import { bool } from 'prop-types'

import { NowLabel } from 'views/components/molecules/NowWidget'

const ProductLabelNow = ({ displayNowWidget, upid }) =>
  displayNowWidget ? (
    <li
      className="u-vertical-align--top u-margin-small--bottom u-margin-small--right o-ProductLabels__ProductLabelContainer"
      data-clientside-hook="nowWidget"
      data-product-identifier={upid}
    >
      <NowLabel />
    </li>
  ) : null

ProductLabelNow.propTypes = {
  displayNowWidget: bool,
  upid: String,
}
ProductLabelNow.defaultProps = {
  displayNowWidget: false,
  upid: null,
}

export default ProductLabelNow
